import React, { useState } from "react";
import '../components/uwin.css'
import PreResgistrationUwin from "../../../modules/uwin/components/Pre-registration-uwin";

const UwinPage=()=>{

    const[showUwin, setShowUwin] = useState(true);

    return(
        <>
            {showUwin && <PreResgistrationUwin onClose={() => setShowUwin(false)} />}
        </>
    )
}

export default UwinPage;